/* eslint-disable no-console */

/**
 * Debugging utility for ads.
 *
 * Listen for events from Google Publisher Tags and log them to the console.
 * Enabled by setting `debugMode: true` in the `mediaPressAdsConfig` object.
 */
function debug() {
  const timing = {};

  // Track when slots are defined by us in the code
  window.addEventListener('mediaPressAdsSlotDefined', function (event) {
    const slot = event.detail.slot;
    const slotId = slot.getSlotElementId();
    timing[slotId] = {
      defined: performance.now(),
    };
    console.log('[AD] 1 - defined', {
      id: slotId,
      time: timing[slotId].defined,
    });
  });

  // Track when an ad is requested for a slot, i.e: preloaded from the ad server
  const observer = new PerformanceObserver((list) => {
    list.getEntries().forEach((entry) => {
      if (entry.name.includes('googlesyndication.com/gampad/ads')) {
        const url = new URL(entry.name);
        const slotId = url.searchParams.get('dids');

        if (slotId) {
          timing[slotId].requested = performance.now();
          console.log('[AD] 2 - requested', {
            id: slotId,
            time: timing[slotId].requested,
            timeSinceDefined: timing[slotId].requested - timing[slotId].defined,
          });
        }
      }
    });
  });
  observer.observe({ entryTypes: ['resource'] });

  // Track when slots are rendered, this is what will impact viewability if the ad is not seen
  window.googletag.pubads().addEventListener('slotRenderEnded', function (event) {
    const slot = event.slot;
    const slotId = slot.getSlotElementId();
    timing[slotId].rendered = performance.now();

    console.log('[AD] 3 - rendered', {
      id: slotId,
      time: timing[slotId].rendered,
      timeSinceRequested: timing[slotId].rendered - timing[slotId].defined,
    });
  });

  // Track when ads become viewable, i.e: 50%+ of pixels are in the viewport for >1 second
  window.googletag.pubads().addEventListener('impressionViewable', function (event) {
    const slot = event.slot;
    const slotId = slot.getSlotElementId();
    timing[slotId].viewable = performance.now();

    console.log('[AD] 4 - viewable', {
      id: slotId,
      time: timing[slotId].viewable,
      timeSinceRendered: timing[slotId].viewable - timing[slotId].rendered,
    });
  });
}

export default debug;
